import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  createConsentRequestModal,
  createConsentTCModal,
} from '../components/modals/factories';

const propTypes = {
  showConsentModal: PropTypes.bool,
  isMobile: PropTypes.bool,
  user: PropTypes.object,
  accountDomain: PropTypes.string,
  openModal: PropTypes.func,
  hasToShowTCModalConsent: PropTypes.bool,
};

const defaultProps = {
  showConsentModal: false,
  isMobile: false,
  user: {},
  accountDomain: '',
  openModal: () => {},
  hasToShowTCModalConsent: false,
};

const ConsentModal = ({
  showConsentModal,
  isMobile,
  user,
  accountDomain,
  openModal,
  hasToShowTCModalConsent,
}) => {
  const [canShow, setCanShow] = useState(true);

  useEffect(() => {
    if (hasToShowTCModalConsent && canShow) {
      openModal(createConsentTCModal({
        isMobile,
        user: user.sess,
        accountDomain,
        from: '',
      }));
      setCanShow(false);
    }
  }, [hasToShowTCModalConsent, canShow]);

  /**
   * Modal for marketing consent
   */

  useEffect(() => {
    if (showConsentModal && canShow) {
      openModal(createConsentRequestModal({
        type: showConsentModal,
        isMobile,
        user: user.sess,
        accountDomain,
        from: '',
        medium: 'GoogleOneTap',
      }));
      setCanShow(false);
    }
  }, [showConsentModal, canShow]);

  return null;
};

ConsentModal.propTypes = propTypes;
ConsentModal.defaultProps = defaultProps;
export default ConsentModal;
